export const MEMBERSHIP_GOALS_HEADING =
  "What do you most want books to do for your child right now?";

export type MembershipGoalOption = {
  id: string;
  label: string;
  value: string;
  /** Short copy for compact pills (e.g. reading level confirmation card). */
  pillLabel: string;
  /** Pill row expands with free-text field when selected. */
  kind?: "default" | "other";
};

export const MEMBERSHIP_GOAL_OPTIONS: MembershipGoalOption[] = [
  {
    id: "spark-love-reading",
    label: "Spark a love of reading",
    value: "spark_love_reading",
    pillLabel: "Inspire Reading",
  },
  {
    id: "surprise-favorites",
    label: "Surprise us with new favorites & authors",
    value: "surprise_favorites_authors",
    pillLabel: "Include Surprises",
  },
  {
    id: "special-time",
    label: "Make reading our special time together",
    value: "special_time_together",
    pillLabel: "Read Together",
  },
  {
    id: "home-library",
    label: "Build a home library they're proud of",
    value: "home_library_proud",
    pillLabel: "Build a Library",
  },
  {
    id: "confidence-comprehension",
    label: "Grow confidence & comprehension (without the homework vibe)",
    value: "confidence_comprehension",
    pillLabel: "Grow Confidence",
  },
  {
    id: "diverse-voices",
    label: "Explore diverse voices & real-world topics",
    value: "diverse_voices_topics",
    pillLabel: "Explore Diverse Topics",
  },
  {
    id: "independent-reading",
    label: "Encourage more independent reading",
    value: "independent_reading",
    pillLabel: "Encourage Independence",
  },
  {
    id: "other",
    label: "Other",
    value: "other",
    pillLabel: "Other",
    kind: "other",
  },
];

/** Preset goal slugs sent to the API (excludes user-typed "other" detail). */
export const MEMBERSHIP_GOAL_PRESET_VALUES: ReadonlySet<string> = new Set(
  MEMBERSHIP_GOAL_OPTIONS.map((o) => o.value)
);
